import React, { useState } from 'react';

const InjuriesNonLostTimeForm = ({ onFormSubmit, loading, error, incidentId, additionalFormLoading }) => {
  const [formState, setFormState] = useState({
    employeeName: '',
    dateOfInjury: '',
    description: ''
  });

  const handleChange = (e) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formState.employeeName || !formState.dateOfInjury || !formState.description) {
      alert('All fields are required.');
      return;
    }
    if (onFormSubmit) {
      onFormSubmit(formState, incidentId);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>Employee Name</label>
        <input
          name="employeeName"
          value={formState.employeeName}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label>Date of Injury</label>
        <input
          name="dateOfInjury"
          type="date"
          value={formState.dateOfInjury}
          onChange={handleChange}
          required
        />
      </div>
      <div>
        <label>Description</label>
        <textarea
          name="description"
          value={formState.description}
          onChange={handleChange}
          required
        />
      </div>
      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
      <button 
        type="submit" 
        disabled={additionalFormLoading}
        className={additionalFormLoading ? 'submit-button disabled' : 'submit-button'}
      >
        {additionalFormLoading ? 'Submitting...' : 'Submit'}
      </button>
    </form>
  );
};

export default InjuriesNonLostTimeForm;
